// @ts-nocheck

import React, { createContext, useContext, useMemo, useState } from 'react';

type OnLoginSucceed = (...params: unknown) => unknown;

type AppContextProps = {
  onLoginSucceed?: OnLoginSucceed;
  setOnLoginSucceed: (onLoginSucceed: OnLoginSucceed) => void;
};

const AppContext = createContext<AppContextProps>({});

export const useAppContext = () => useContext(AppContext);

type AppContextProviderProps = {
  children: React.ReactNode;
};

const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [onLoginSucceed, setOnLoginSucceed] = useState(() => {});

  const forwardedState = useMemo(() => ({ onLoginSucceed, setOnLoginSucceed }), [onLoginSucceed, setOnLoginSucceed]);

  return <AppContext.Provider value={forwardedState}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
